import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { callApi, getInlineLoader } from "../Helpers";
import { STR_BUSINESS_NAME, STR_BUSINESS_TYPE, STR_CHANGE_BUSINESS, STR_COMPANY, STR_CONTACT_US, STR_GET_FREE_TRIAL, STR_INVALID_BUSINESS_NAME, STR_OPTIONAL, STR_PLEASE_REGISTER_BUSINESS, STR_REGISTER_BUSINESS, STR_REGISTER_NEW, STR_SELECT_THIS, STR_SOLE_PROPRIETOR, STR_SUBMIT, STR_SUCCESS, STR_WEBSITE_URL } from "../Strings";
import MobileInterface from "../MobileInterface";

import { FaTelegram, FaWhatsapp } from "react-icons/fa";
import { MdCall, MdCheckCircle, MdEmail, MdLogin } from "react-icons/md";
import { TiWarningOutline } from "react-icons/ti";


export default function ContactUs(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getCurrentUserData(),
		])
		setReady(true);
	}

	

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">

						<div className="col-md-12">
							<h6 className="main-section-title">
								{STR_CHANGE_BUSINESS[appContext.language]}
							</h6>
						</div>

						<div className="col-md-12">

							<div className="text-end mb-4">
								<button
									className="btn btn-sm btn-padded btn-rounded btn-primary mt-4"
									onClick={() => {
										appContext.navTo({
											item: 'view',
											subItem: 'register-business',
										})
									}}
								>
									{STR_REGISTER_NEW[appContext.language]}
								</button>
							</div>
							
							{
								(appContext.currentUserData && appContext.currentUserData.businesses.length > 0) ?
								<div
									className=""
								>
									{
										appContext.currentUserData.businesses.map((item, i) => {
											return (
												<div className="card" key={i}>
													<div className="card-body">
														<h6
															style={{
																fontSize: "18px"
															}}
														>
															{item.businessName}
														</h6>

														<div className="text-end">
															{
																(appContext.currentBusiness.businessUuid === item.businessUuid) ?
																<h6
																>
																	<MdCheckCircle className="text-secondary" size={32}/>
																</h6>
																:
																<button
																	className="btn btn-sm font-bold text-secondary"
																	onClick={() => {
																		appContext.setCurrentBusiness(item);
																	}}
																>
																	<MdLogin size={24}/> {STR_SELECT_THIS[appContext.language]}
																</button>
															}
														</div>
													</div>
												</div>
											)
										})
									}
								</div>
								:
								<div>
									<hr/>
									<h6
										style={{
											fontSize: "14px"
										}}
										className="font-semi-bold"
									>
										<TiWarningOutline size={42}/>
										<br/>
										{STR_PLEASE_REGISTER_BUSINESS[appContext.language]}
									</h6>
			
									<div className="text-end">
										<button
											className="btn  btn-padded btn-rounded btn-primary mt-4"
											onClick={() => {
												appContext.navTo({
													item: 'view',
													subItem: 'register-business',
												})
											}}
										>
											{STR_REGISTER_BUSINESS[appContext.language]}
										</button>
									</div>
								</div>
							}
							
						</div>

					</div>

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}